import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { UploadDropzoneBorderComponent } from '../upload-dropzone-border/upload-dropzone-border.component';
import { FilesizePipe } from '../../../file-size/pipes/file-size.pipe';

@Component({
  selector: 'app-upload-single-dropzone',
  imports: [FilesizePipe, UploadDropzoneBorderComponent],
  templateUrl: './upload-single-dropzone.component.html',
  styleUrl: './upload-single-dropzone.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UploadSingleDropzoneComponent {
  @Input({ required: true }) public maxFileSize!: number;
}
